<template>
  <div id="contenedor-registrar-nuevo-contratista">
    <custom-button
      v-if="mixValidaScopesActions(1)"
      :onlyIcon="onlyIcon"
      @click="mostrarDialogo = true"
      :label="onlyIcon ? '' : 'Nuevo'"
      iconText="mdi-plus"
      tipo="agregar">
    </custom-button>
    <v-dialog
      v-model="mostrarDialogo"
      width="90%">
      <v-form
        v-model="formularioValido"
        ref="registrarNuevoContratista">
        <v-card>
          <v-card-title class="secondary--text">
            Registrar nuevo contratista
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="cerrar">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <custom-text-field
                cols="12"
                sm="6"
                md="4"
                v-model="contratista.rfc"
                label="RFC"
                :rules="[mixReglas.requerido]">
              </custom-text-field>
              <custom-text-field
                cols="12"
                sm="6"
                md="5"
                v-model="contratista.nombreRazonSocial"
                label="Nombre Razon Social"
                :rules="[mixReglas.requerido]">
              </custom-text-field>
              <custom-text-field
                cols="12"
                sm="3"
                md="3"
                v-model="contratista.nacionalidad"
                label="Nacionalidad">
              </custom-text-field>
              <custom-text-field
                cols="12"
                sm="7"
                md="4"
                v-model="contratista.calle"
                label="Calle">
              </custom-text-field>
              <custom-text-field
                cols="6"
                sm="2"
                v-model="contratista.numero"
                label="#">
              </custom-text-field>
              <custom-text-field
                cols="6"
                sm="4"
                md="3"
                v-model="contratista.colonia"
                label="Colonia">
              </custom-text-field>
              <custom-text-field
                cols="6"
                sm="4"
                md="3"
                v-model.number="contratista.codigoPostal"
                label="CP"
                type="number"
                :rules="[mixReglas.codigoPostal]">
              </custom-text-field>
              <custom-text-field
                cols="6"
                sm="4"
                md="4"
                v-model="contratista.entidad"
                label="Entidad">
              </custom-text-field>
              <custom-text-field
                cols="12"
                sm="4"
                md="4"
                v-model="contratista.municipio"
                label="Municipio">
              </custom-text-field>
              <custom-text-field
                cols="12"
                sm="8"
                md="4"
                v-model="contratista.nombreRepresentante"
                label="Nombre Representante">
              </custom-text-field>
              <custom-text-field
                cols="12"
                sm="6"
                md="4"
                v-model="contratista.correoElectronico"
                label="Correo"
                :rules="[mixReglas.requerido, mixReglas.email]">
              </custom-text-field>
            </v-row>
          </v-card-text>
          <v-divider class="bkground" />
          <v-card-actions>
            <v-spacer></v-spacer>
            <custom-button
              @click="cerrar"
              tipo="formCancelar"
              label="Cancelar"
              class="mr-3">
            </custom-button>
            <custom-button
              @click="mixAgregarContratista"
              tipo="formAceptar"
              label="Guardar"
              :disabled="!formularioValido || enviandoFormulario">
            </custom-button>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import mixCatalogoContratistas from './mixCatalogoContratistas';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'RegistrarNuevoContratista',
  mixins: [mixCatalogoContratistas],
  components: {
    CustomTextField,
    CustomButton,
  },
  props: {
    onlyIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mostrarDialogo: false,
      formularioValido: false,
      enviandoFormulario: false,
      test: '',
      contratista: {
        // idCliente: 'a98aa86a-b3ff-41de-9a2b-c8c7d6f9be27',
        rfc: '',
        nombreRazonSocial: '',
        nacionalidad: '',
        calle: '',
        numero: '',
        colonia: '',
        codigoPostal: null,
        entidad: '',
        municipio: '',
        nombreRepresentante: '',
        correoElectronico: '',
        favorito: false,
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevoContratista.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
      this.mostrarDialogo = false;
    },
  },
};
</script>

<style lang="scss">

</style>
